export default {
  methods: {
    // Decode double-quoted html-string
    decode(html) {
      if (process.client) {
        const decoder = decoder || document.createElement('div');
        decoder.innerHTML = html;
        return decoder.textContent;
      }
    },
    // Smart cutting in chars length, rounding up to ceil word
    cut(str, length) {
      if (+length > 0) {
        const words = str.split(' ');
        let resultStr = '';
        words.forEach(word => {
          if (resultStr.length < +length) {
            resultStr += ' ' + word;
          }
        });
        if (resultStr.length < str.length) resultStr += '...';
        return resultStr;
      } else {
        return str;
      }
    },
    // Cut document name, saving it's extension
    cutDocName(str, length = 0) {
      const regex = /(.*)(\.([^\s]*)?)/gm;

      const m = regex.exec(str);
      let resultFile = str;
      let resultExt = '';

      if (m) {
        resultFile = str.replace(regex, '$1');
        resultExt = str.replace(regex, '$2');
      }
      const resultFileTrimmed = resultFile.length > length ? resultFile.substring(0, length - 3) + "..." : resultFile;
      return resultFileTrimmed + resultExt;
    },
    // convert product type to url code
    paramCode(categoryFullStr) {
      switch (categoryFullStr) {
        case 'outdoor':
          return 'outd';
        case 'indoor':
          return 'ind';
        case 'special':
          return 'spec';
        case 'city':
          return 'city';
        default:
          return '';
      }
    },
    videoYoutube(url) {
         if(url) {
           const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
           const match = url.match(regExp);
           return (match && match[7].length === 11) ? match[7] : '';
         }
         return  false;
    }
  },
};



// WEBPACK FOOTER //
// ./components/shared/mixins/StringMixin.js